import type { TableColumnSize } from '@cli-types/core-engine/schema.js'

export const ENTITY_ACTION_FIELD_EXCLUSIONS = new Set(['id', 'createdAt', 'updatedAt', 'sortOrder'])
export const SINGLE_ACTION_FIELD_EXCLUSIONS = new Set(['id', 'createdAt', 'updatedAt'])
export const DEFAULT_ADMIN_IMPORT_ALIAS = '@admin'
export const SAMPLE_UUID = '00000000-0000-4000-8000-000000000001'
export const SINGLETON_ID = '00000000-0000-0000-0000-000000000001'
export const SAMPLE_FORMATTED_TIMESTAMP = 'Jan 01, 2026'
export const AUTHORSHIP_FIELD_NAMES = ['createdBy', 'updatedBy'] as const
export const TABLE_COLUMN_SIZE_PRESETS: Record<TableColumnSize, number> = {
  sm: 120,
  default: 220,
  lg: 320,
  xl: 420
}
export const NO_NAV_SCHEMAS = new Set(['settings'])
// The settings singleton is admin configuration, not site content — it never
// fires webhooks (same exclusion pattern as NO_NAV_SCHEMAS).
export const NO_WEBHOOK_SCHEMAS = new Set(['settings'])
